import * as React from 'react';
import { times } from 'lodash';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import ManagerCard from './components/ManagerCard';
import { ManagerCardLoader } from 'src/share/components/ChartLoader/ManagerCardLoader';
import { useUsers } from 'src/modules/UserSettings/Users/hooks/useUsers';
import useDebounce from 'src/share/hooks/useDebounce';
import useInfiniteScroll from 'src/share/hooks/useInfiniteScroll';
import useDidUpdateEffect from 'src/share/hooks/useDidUpdateEffect';
import { IUserSearch } from 'src/share/types/user';
import { RoutesModules } from 'src/modules/Routing/types';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { SearchBox } from 'src/share/components/Filter/SearchBox';
import { SortBox } from 'src/share/components/Filter/SortBox';

const sortOptions = {
  agencyCode: 'Agency',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
};

const initialSearch: IUserSearch = {
  sort: [],
  page: 0,
  size: 12,
  queryString: "",
  isAppended: true
};

function ManagersView(): React.ReactElement {
  const observer = React.useRef();
  const [search, setSearch] = React.useState(initialSearch);
  const usersData = useUsers(search);
  const [hasMore, setHasMore] = React.useState(false);
  const [filterText, setFilterText] = React.useState("");
  const debouncedSFilterText = useDebounce(filterText, 500);
  const { handleLastImageRef } = useInfiniteScroll(observer, hasMore, usersData.isLoading, handleLastRef);
  useDidUpdateEffect(() => {
    setSearch(prevSearch => {
      if (debouncedSFilterText) {
        return { page: 0, queryString: debouncedSFilterText, isAppended: false, sort: prevSearch.sort };
      }
      return { ...prevSearch, size: initialSearch.size, page: 0, isAppended: false, queryString: "" };
    })
  }, [debouncedSFilterText]);
  useDidUpdateEffect(() => {
    setHasMore(usersData.users.length < usersData.total);
  }, [usersData]);
  function handleSearchChanged(text): void {
    setFilterText(text);
  }
  function handleSorted(sort): void {
    setSearch(prevSearch => ({ size: initialSearch.size, sort: [{ [sort]: 'asc' }], page: 0, queryString: prevSearch.queryString, isAppended: false }));
  }
  function handleLastRef(): void {
    setSearch(prevSearch => ({ ...prevSearch, size: initialSearch.size, page: prevSearch.page + 1, isAppended: true }));
  }
  return (
    <div>
      <div className="filters-box">
        <SearchBox onSearch={handleSearchChanged} />
        <SortBox onSort={handleSorted} options={sortOptions} />
      </div>
      <div className="managers-view">
        <Row style={{ margin: '0' }}>
          {(usersData.isLoading === false || search.isAppended) && usersData.users.map((manager, index) => (
            <ManagerCard
              key={manager.managerId}
              manager={manager}
              refElement={usersData.users.length === index + 1 ? handleLastImageRef : null}
            />
          ))}
          {usersData.isLoading && times(10, Object).map((e, index) =>
            <Col key={`skeleton-${index}`} xl="4" lg="6" md="12" sm="12" xs="12" className="card-column">
              <ManagerCardLoader />
            </Col>
          )}
          {!usersData.isLoading && !usersData.users.length && <h4 className="no-results">No data found</h4>}
        </Row>
      </div>
    </div>
  )
}

export default SidebarContainer(RoutesModules.AGENCIES)(ManagersView);
